<template>
    <div>
        <div class="row" style="display:none">
            <i>Colors Computer Kft., 6724, Szeged, Kossuth Lajos sgt. 60. Tel: 62/329927, 30/9569859, www.colors-computer.hu, colors@colors-computer.hu</i>
        </div>
        <div class="row mt-4">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <h1 class="text-primary">Szerviz munkalap szerkesztése</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="edit" v-model="editModeInput">
                    <label class="form-check-label" for="edit">Szerkesztés bekapcsolása</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <notification :show="showNotification" :errors="saveError"></notification>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <record-data
                    :worksheet="worksheet"
                    :disabled="editMode"
                    :users="users"
                    :statusOptions="statusOptions"
                >

                </record-data>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <client-data :worksheet="worksheet" :disabled="editMode"></client-data>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <informations :worksheet="worksheet" :disabled="editMode"></informations>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-0 col-xl-1"></div>
            <div class="col-lg-3 col-xl-2">
                <button type="submit" class="btn btn-primary btn-block" @click.prevent="save" :disabled="isLoading">
                    <i v-if="isLoading" class="fa fa-spin fa-refresh"></i>
                    <i v-else class="fa fa-save"></i>
                    Mentés
                </button>
            </div>
            <div class="col-lg-3 col-xl-2">
                <button type="submit" class="btn btn-primary btn-block" @click.prevent="print"
                        :disabled="isLoading">
                    <i class="fa fa-print"></i>
                    Nyomtatás
                </button>
            </div>
            <div class="col-lg-3 col-xl-2">
                <button type="submit" class="btn btn-primary btn-block" @click.prevent="tmpFunc"
                        :disabled="isLoading">
                    <i class="fa fa-envelope"></i>
                    Mentés + E-mail
                </button>
            </div>
            <div class="col-lg-3 col-xl-2">
                <button type="submit" class="btn btn-primary btn-block" @click.prevent="tmpFunc"
                        :disabled="isLoading">
                    <i class="fa fa-mobile"></i>
                    Mentés + SMS
                </button>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <h4 class="text-primary">Elvégzett munkák, események</h4>
            </div>
        </div>
        <events
            :worksheetEvents="worksheetEvents"
            :users="users"
            :statusOptions="statusOptions"
            @reload="updateData"
        >

        </events>
    </div>
</template>

<script>
    import RecordData from './worksheet/RecordData';
    import ClientData from './worksheet/ClientData';
    import Informations from './worksheet/Informations';
    import Notification from './worksheet/Notification';
    import Events from './worksheet/Events';
    import Comm from '../services/comm';

    export default{
        name: 'EditWorksheet',
        data(){
            return {
                worksheet: {
                    recorder: null,
                    recordTime: new Date(),
                    recordStatus: '',
                    client: {
                        id: null,
                        name: '',
                        address: '',
                        phone: '',
                        email: ''
                    },
                    deviceType: '',
                    colorsNumber: '',
                    deviceUser: '',
                    devicePassword: '',
                    estimatedTime: '',
                    estimatedPrice: '',
                    priceOffer: false,
                    notification: false,
                    comment: '',
                    extraInfo: '',
                    extra: {
                        maintance: false,
                        firmware: false,
                        reinstall: false,
                        burnt: false,
                        switching: false,
                        notStarting: false,
                        update: false,
                        antivirusExpired: false,
                        internet: false,
                        performance: false,
                        cabel: false,
                        installBasic: false,
                        installMini: false,
                        antivirus: false,
                        testing: false,
                        durability: false,
                        datasave: false,
                        dust: false
                    }
                },
                showNotification: false,
                editModeInput: false,
                worksheetEvents: [],
                users: [],
                statusOptions: []
            }
        },
        computed: {
            saveError(){
                return this.$store.state.WorksheetModul.saveError;
            },
            isLoading(){
                return this.$store.state.WorksheetModul.loading;
            },
            editMode(){
                return !this.editModeInput;
            }
        },
        methods: {
            getWorksheet(){
                let id = this.$route.params.id;

                this.$store.dispatch(
                    'WorksheetModul/getWorksheet',
                    {
                        id,
                        result: res => {
                            let data = res.data;
                            for(let index in data.worksheetData.worksheet.extra){
                                if(data.worksheetData.worksheet.extra[index] === "1"){
                                    data.worksheetData.worksheet.extra[index] = true;
                                } else {
                                    data.worksheetData.worksheet.extra[index] = false;
                                }
                            }

                            data.worksheetData.worksheet.recordTime = new Date(data.worksheetData.worksheet.recordTime);
                            if(data.worksheetData.worksheet.notification === "1"){
                                data.worksheetData.worksheet.notification = true;
                            } else {
                                data.worksheetData.worksheet.notification = false;
                            }
                            if(data.worksheetData.worksheet.priceOffer === "1"){
                                data.worksheetData.worksheet.priceOffer = true;
                            } else {
                                data.worksheetData.worksheet.priceOffer = false;
                            }

                            this.worksheet = data.worksheetData.worksheet;
                            this.worksheetEvents = data.worksheetData.worksheetEvents;
                        }
                    }
                );
            },
            save(){
                this.showNotification = false;
                let data = this.worksheet;
                data.id = this.$route.params.id;
                this.$store.dispatch('WorksheetModul/editWorksheet', {
                    data,
                    result: (res) => {
                        this.showNotification = true;
                        this.updateData();
                        window.scrollTo(0,0);
                        this.editModeInput = false;
                    },
                    reject: (rej) => {
                        this.showNotification = true;
                        console.error(rej);
                        window.scrollTo(0,0);
                    }
                })
            },
            loadUsers(){
                this.$store.dispatch('UserModul/getUserList', {
                    result: (res)=> {
                        this.users = [];
                        res.data.userList.forEach(user => {
                            this.users.push({
                                label: user.username,
                                value: user.id
                            });
                        });
                    }
                });
            },
            loadEventStatuses(){
                this.$store.dispatch('HelperModul/getEventStatuses', {
                    result: (res) => {
                        if(res !== 'NO_DATA'){
                            this.statusOptions = [];
                            res.eventStatusList.forEach(item => {
                                this.statusOptions.push(item.status);
                            });
                        }
                    },
                    reject: (rej) => {
                        console.error(rej);
                    }
                });
            },
            updateData(){
                this.loadEventStatuses();
                this.getWorksheet();
            },
            print(){
                window.open(Comm.getPrintUrl() + "?worksheetId=" + this.$route.params.id);
            },
            tmpFunc(){

            }
        },
        mounted(){
            this.getWorksheet();
            this.loadUsers();
            this.loadEventStatuses();
        },
        components: {
            RecordData,
            ClientData,
            Informations,
            Notification,
            Events
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/EditWorksheet.vue